export const events = {
  STEPCLICK: 'step-click'
};
